<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="{{ 'inventory.title' | translate }}" [backWithParams]="true">
  <ng-template #addButton>
    <div class="d-flex search-field">

      <div class="create_btn_sd">
        <button mat-icon-button color="primary"  aria-label="option menu"
        [matMenuTriggerFor]="menu">
            <mat-icon>add</mat-icon> 
            <!-- Activity -->
        </button>
    </div>

      <!-- <button mat-button aria-label="option menu"
      [matMenuTriggerFor]="menu" color="accent" >
      <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
      </button> -->

      <mat-menu #menu="matMenu">
        <button  mat-menu-item (click)="onRecordUsage()" >
          <mat-icon class="material-icons-outlined">done</mat-icon>
          <span>{{ 'inventory.op1_record_usage' | translate }}</span>
        </button>
        <button  mat-menu-item (click)="OnIncreaseStock()" [disabled]="!isOwner">
          <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
          <span>{{ 'inventory.op2_increase_stock' | translate }}</span>
        </button>
       
      </mat-menu>
    </div>
  </ng-template>
</sm-title-bar>
<div class="bradcamp_inventory"  *ngIf="!loader">
  <div class="over_sectionkl" style="border-bottom: 1px solid #ddd;margin-bottom: 20px;padding-bottom: 12px;">
    <div class="overall_count_s">
    <p>Overall count</p>
    <h3>{{inventoryStatus.total_items_count}}</h3>
    </div>
    <div class="overall_count_s" style="border-right: none !important;">
    <p>Out of stock</p>
    <h3>{{inventoryStatus.out_of_stock_count}}</h3>
    </div>
</div>
<div class="over_sectionkl">
<div class="overall_count_s" style="padding-right: 15% !important;">
  <p>Minimum stock</p>
  <h3>{{inventoryStatus.low_stock_count}}</h3>
</div>
<div class="view_items_btn" style="border-right: none !important;">
  <button mat-flat-button color="primary" mat-button aria-label="option menu" (click)="openInventoryItems()">
    View all items
  </button>
</div>
</div>
</div>

<!-- 

<mat-card appearance="outlined" *ngIf="!loader && inventoryActivityData.length > 0">
  <sm-title-bar pageSubTitle="Inventory Activity"></sm-title-bar>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumn" [dataSource]="inventoryActivityData" [showImageColumn]="true"  [imageTemplate]="image" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"></sm-data-table>
  </div>
</mat-card> -->


<div *ngIf="!loader && inventoryActivityData.length > 0">
  <div class="row">
    <div class="col-sm-6 col-md-6 col-12" *ngFor="let item of inventoryActivityData">
  <div class="service-card" >
    <div class="card-content">
      <div class="service-image">
        <div style="position: relative;">
          <div class="booking-initial" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">{{item.item_name.slice(0,1).toUpperCase()}}</div>
          <img
          *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'"
            [src]="item.image_thumb_url"
            onerror="this.src='../../../../assets/images/photo.png'"
            class="img-fluid rounded-circle"
            style="border: 1px solid lightgray; width: 50px; height: 50px; object-fit: cover;"
          />
          <mat-icon
          *ngIf="item.operation_type == 1"
            class="status-icon"
            style="background-color: green;
            position: absolute;
            bottom: -4px;
            color: #fff;
            border-radius: 50%;
            left: 30px;
            width: 20px;
            font-size: 20px;
            height: 20px;"
            class="material-icons-round"
          >arrow_downward</mat-icon>
          <mat-icon
          *ngIf="item.operation_type == 2"          
            class="status-icon"
            style="background-color: red;
            position: absolute;
            bottom: -4px;
            color: #fff;
            border-radius: 50%;
            left: 30px;
            width: 20px;
            font-size: 20px;
            height: 20px;"
            class="material-icons-round"
          >arrow_upward</mat-icon>
       
        </div>
      </div>
  
      <div class="service-details">
        <h3 class="service-title">{{item.item_name}}</h3>
        <p class="service-sub">{{item.p_quantity}} </p>
        <p class="service-date">{{item.activity_type | uppercase}}, {{item.creation_time | date}}</p>
        <p class="service-date" style="font-size: 12px;" *ngIf="item.notes && item.notes != 'null'">{{item.notes}}</p>

        <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button" >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onRevertUsage(item)" [disabled]="checkDisablity(item)">
            <mat-icon class="material-icons-outlined">edit</mat-icon>
            <span>{{ 'inventory.op1_revert_usage' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  </div>
</div>
</div>


<!-- <ng-template #menuTemplate let-rowvalue >
  
  <button mat-menu-item (click)="onRevertUsage(rowvalue)" [disabled]="checkDisablity(rowvalue)">
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span>{{ 'inventory.op1_revert_usage' | translate }}</span>
  </button>
  
</ng-template> -->
<!-- 
<ng-template #image let-objValue>
  <div style="position: relative;">
    <img
      [src]="
        objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
          ? objValue['image_thumb_url']
          : '../../../../assets/images/photo.png'
      "
      class="img-fluid rounded-circle" style="border: 1px solid lightgray;"
    />
    
    <mat-icon style="height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: -5px;
    font-size: 20px !important;
    left: 25px;
    background-color: green;
    color: white;" *ngIf="objValue['operation_type'] == 1" class="material-icons-round">arrow_upward</mat-icon>
    <mat-icon style="height: 20px;
    width: 20px;
    border-radius: 50%;
    display: block;
    position: absolute;
    bottom: -5px;
    font-size: 20px !important;
    left: 25px;
    background-color: red;
    color: white;" *ngIf="objValue['operation_type'] == 2" class="material-icons-round">arrow_downward</mat-icon>
    </div>
</ng-template> -->

<mat-paginator
*ngIf="!loader && inventoryActivityData.length > 0"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>



<!-- <ng-container>

  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
  
      <h3>
        Inventory items are coming
      </h3>
      <p>
        We are working hard day and night to bring this for you.
      </p>
    </div>
  </div>   
</ng-container> -->


  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && inventoryActivityData.length == 0">
        <div class="row">
          <div class="col-sm-6 col-md-6 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/statistics-reports.jpg">
                 </div>
                 <mat-card-title>No inventory activity</mat-card-title>
                 <mat-card-content>There's no inventory In or Out activity here. Once you start adding purchase and finish records, they'll appear here.
                </mat-card-content>
                 <div class="watch_vc_btn">
                  <button mat-flat-button color="primary" mat-button aria-label="option menu"
                  [matMenuTriggerFor]="menu">
                      <mat-icon>add</mat-icon> 
                      Activity
                  </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          
          <div class="col-sm-6 col-md-6 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/inventory-activity.png">
                 </div>
                 <mat-card-title>What is inventory activity?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on inventory activity related to new purchase, increase stock and record finish of inventory item.
                </mat-card-content>
                 <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" >
                    <mat-icon>help</mat-icon>
                   See help doc
                 </button>
                 <mat-menu #menu="matMenu" >
                  <button  mat-menu-item (click)="onRecordUsage()" >
                    <mat-icon class="material-icons-outlined">check_small</mat-icon>
                    <span>{{ 'inventory.op1_record_usage' | translate }}</span>
                  </button>
                  <button  mat-menu-item (click)="OnIncreaseStock()" [disabled]="!isOwner">
                    <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
                    <span>{{ 'inventory.op2_increase_stock' | translate }}</span>
                  </button>
                 
                </mat-menu>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-6 col-md-6 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding inventory activity record or in getting incorrect activity data, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->